






import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";

import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import PersonaCorreo from "@/models/persona/personaCorreo.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import EditarCorreoComponent from "@/components/correo/editarCorreo.vue";

@Component({
  components: { EditarCorreoComponent }
})
export default class PerfilCiudadanoListaCorreos extends BaseVue {
  @Prop() readonly personaId!: number;
  protected repository!: BaseRepository<PersonaCorreo>;

  constructor() {
    super();
    this.repository = new BaseRepository<PersonaCorreo>("personacorreo");
  }
 
  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp("personaId", "number")
    );
    this.$emit("render", props);
  }
  onAdd(added: PersonaCorreo) {}

  editar() {}

  quitar() {
    this.$buefy.dialog.confirm({
      title: "Confirmación",
      message: "¿Desea eliminar este correo?",
      confirmText: "Adelante!",
      cancelText: "Cancelar",
      type: "is-danger",
      size: "is-medium",
      hasIcon: true,
      onConfirm: () => this.eliminar(0)
    });
  }

  async eliminar(correoId:number) {
    try {
      await this.repository.delete(correoId);
      this.operationSuccess("Teléfono eliminado!");
    } catch (e) {
      this.operationFailed(e);
    }
  }
}
